<template>
  <!-- <template v-slot:header> Hola </template> -->
  <v-text-field
    v-model="inputValue"
    v-bind:label="textLabel"
    v-bind:placeholder="textPlaceholder"
    v-bind:hint="textHint"
    v-bind:rules="CreditRules"
    outlined
    dense
  ></v-text-field>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
export default {
  name: "creditCard",
  props: ["textLabel", "textPlaceholder", "textHint", "value"],
  methods: {
    objectTranslator,
  },
  data() {
    return {
      CreditRules: [validator.credit],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
